import { ICaseDecisionService } from "../service/CaseDecisionService";

export default class PublishCaseDecisionInteractor {
  private caseDecisionService: ICaseDecisionService;

  constructor({ caseDecisionService }: any) {
    this.caseDecisionService = caseDecisionService;
  }

  async execute(caseDecisionId: string) {
    return this.caseDecisionService.publishCaseDecision(caseDecisionId);
  }
}
